export default __webpack_public_path__ + "static/media/Technicaldrawings.67049cfc.svg";